export var ReferenceOneInputPrefix = '@@ra-one/';
